/* eslint-disable camelcase */
import {
    SET_SURGERY_DETAILS,
    SET_CART_DATA,
    UPDATE_CART_DATA,
    UPDATE_CART_DATA_SHIPPING,
    SET_SHIPPING_DETAILS,
    HANDLE_SURGERY_NOTES,
    SET_PRICING_NOTES,
    SET_VISUALIZATION_INSPECTION,
    RESET_SURGERY_DETAILS,
    CHANGE_SHIPPING_SEGMENT_INDEX,
    SET_SHIPPING_DETAILS_EDIT_MODE,
    SET_SHIPPING_ADDRESS,
    CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
    DISABLE_SURGERY_DATE,
    NOTES_VISITED,
    CURRENT_SURGERY_DATE_SELECTED,
    CHANGE_ACKNOWLEGMENT_VIEW,
    SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
    PUT_RECENTLY_USED_PHYSICIANS,
    PUT_RECENTLY_USED_PHYSICIANS_SUCCESS,
    PUT_RECENTLY_USED_PHYSICIANS_FAILURE,
    GET_DERIVED_TERRITORIES,
    SET_DERIVED_TERRITORIES_SUCCESS,
    SET_DERIVED_TERRITORIES_FAILURE,
    GET_HOLIDAY_LIST_SUCCESS,
    SET_SURGERY_DETAILS_GENERIC,
    SET_PRODUCT_TEMPLATE_UID,
    SET_UNKNOWN_CHECKBOX,
    SET_REQUEST_DELIVERY_DATE,
    CLEAR_PO_NUMBER,
    SET_SHIP_TO_ADDRESS_VALUE,
} from '../actions';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { generate_UUID } from 'src/utils/util';
import { SET_SURGERY_NUMBER } from '../actions/actionTypes';
import {
    SET_IMPLANT_AND_INSTRUMENT_PRODUCTS,
    SET_ITEM_LIST_CLICKED,
} from '../actions/actionTypes';

const updateCartProducts = (products, { operation, productKey, isSet, cfn }) => {
    var clonedProducts = [...products];
    const index = clonedProducts.findIndex(
        (item) => 
      
            item.productKey === productKey
    );
    if (operation === 'increment' && isSet) {
        const cloneProd = { ...clonedProducts[index] };
        delete cloneProd.lineNumber;
        clonedProducts.push({
            ...cloneProd,
            productKey: generate_UUID(),
            shippingRequirement: true,
            batchId: null,
            isDeleteButtonPresent: true,
            reservationBatchId: null,
            reservationBatchCurrentLocation: null,
        });
    } else if (operation === 'decrement' && isSet) {
        clonedProducts.splice(index, 1);
    } else if (operation === 'increment' && !isSet) {
        clonedProducts[index].quantity = clonedProducts[index].quantity + 1;
        if (clonedProducts[index].isAddItemRuleProduct === true) {
            clonedProducts[index].userAddedQuantity =
                (Number(clonedProducts[index].userAddedQuantity) || 0) + 1;
        }
    } else if(operation === 'delete'){
        clonedProducts = (clonedProducts || []).filter((data)=>data.productKey!==productKey);
    }else {
        clonedProducts[index].quantity = clonedProducts[index].quantity - 1;
        if (clonedProducts[index].isAddItemRuleProduct === true) {
            clonedProducts[index].userAddedQuantity = Math.max(
                0,
                (Number(clonedProducts[index].userAddedQuantity) || 0) - 1
            );
        }
    }

    return clonedProducts;
};

const updateCartProductsShipping = (
    products,
    fieldsToBeAdded,
    productKeys,
    isReservationBatch
) => {
    const clonedProducts = [...products];
    for (let i in productKeys) {
        for (let j in clonedProducts) {
            if (productKeys[i] === clonedProducts[j].productKey) {
                !isReservationBatch
                    ? (clonedProducts[j] = {
                          ...clonedProducts[j],
                          ...fieldsToBeAdded,
                      })
                    : (clonedProducts[j] = {
                          ...clonedProducts[j],
                          reservationBatchCurrentLocation:
                              fieldsToBeAdded.batchCurrentLocation,
                          reservationBatchId: fieldsToBeAdded.batchId,
                          reservationBatchParked: fieldsToBeAdded.batchParked,
                          shippingRequirement:
                              fieldsToBeAdded.shippingRequirement,
                          reservationBatchAlreadyAllocated:
                              fieldsToBeAdded.batchAlreadyAllocated,
                      });
                if (fieldsToBeAdded.shippingRequirement)
                    clonedProducts[j].batchId = null;

                break;
            }
        }
    }
    return clonedProducts;
};

const handlePayloadFunc = (stateValues, payload, objParams) => {
    var value4 = { ...stateValues };

    // objParams
    //     ? (value4[Object.keys(payload)[0]][payload.objParams] =
    //           payload[Object.keys(payload)[0]])
    //     : payload;

    var objElement = objParams
        ? (value4[Object.keys(payload)[0]][payload.objParams] =
              payload[Object.keys(payload)[0]])
        : payload;

    return objElement;
};

const initialState = {
    formType: 'AddSurgery/ModifySurgery',
    surgeryDetails: {
        districtId: '',
        territoryId: '',
        procedureCode: '',
        accountId: '',
        surgeryDateTime: '',
        surgeryRequestDeliveryDateTime: '',
        surgeryDuration: '1:00:00',
        physicianId: '',
        submittedPhysicianId:'',
        caseCoverageId: '',
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
        patientDOB: '',
        patientContactName: '',
        patientContactNumber: '',
        inventoryShipping: false,
        physicianDropDown: '',
        template: '',
        surgeryTimeWithoutEDT: '',
        physicianFieldText: '',
        physicianTextBoxType: 'known',
        surgeryNumber: '',
        isMastOrder: false,
        isTransferOrder: false,
        billToId: '',
    },
    notes: [],
    pricingNotes: '',
    cartData: {
        products: [],
        templateUId: '',
    },
    productTemplateUID: '',
    shippingDetails: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
            attention: '',
            payment: {
                poAttachment: '',
                poNumber: '',
            },
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
            attention: '',
            payment: {
                poAttachment: '',
                poNumber: '',
            },
            salesOrg: '',
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
    },
    shipToAddressValue: {},
    derivedTerritoryDetails: {},
    derivedTerritoryLoading: false,
    derivedTerritoryStatusCode: 0,
    derivedTerritoryStatusMessage: '',
    visualInspectionAcknowledgement: false,
    surgeryLoading: false,
    surgeryError: false,
    selectedShippingSegment: 0, // Selected segment of shipping section
    tissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    nonTissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    disableSurgeryDate: false, // disable surgery date of details section for past date
    isNotesVisited: false, //enable surgery date when we navigate to Surgery notes section and return back to details Page
    currentSurgeryDateSelected: false,
    showAcknowlegment: {
        tissue: false,
        nontissue: false,
    },
    surgeryCUInProgress: true,
    recenlyUsedPhysicians: {},
    isHoliday: '',
    sameBatchAllocationError: false,
    shippingAddress: {},
    callCartProductsValidation: true,
    visitedShipping: false,
    unknownCheckbox: false,
    isItemListClicked: false,
    isLastIndividualCheck: false,
    implantProducts: [],
    instrumentProducts: [],
    setImplantProducts: [],
    setInstrumentProducts: [],
    itemImplantProducts: [],
    itemInstrumentProducts: [],
};

const SurgeryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SURGERY_DETAILS:
            return {
                ...state,
                surgeryDetails: {
                    ...state.surgeryDetails,
                    patientContactName:
                        state.surgeryDetails.patientContactName.trim(),
                    ...action.payload,
                },
            };
        case SET_CART_DATA: {
            // Enhanced reducer case for more reliable cart updates
            const timestamp = new Date().toISOString().substr(11, 12);
            
            // When payload contains products, we're updating the cart contents
            if (action.payload.products) {
                
                // Deep clone to ensure no reference issues
                const newProducts = [...action.payload.products];
                
                return {
                    ...state,
                    cartData: {
                        ...state.cartData,
                        products: newProducts,
                        templateUId: action.payload.templateUId 
                            ? { ...action.payload.templateUId }
                            : action.payload.templateUId === ''
                            ? ''
                            : state.cartData.templateUId,
                        lastUpdated: Date.now() // Add timestamp for tracking updates
                    },
                };
            } 
            // Only updating template ID
            else {
                return {
                    ...state,
                    cartData: {
                        ...state.cartData,
                        templateUId: action.payload.templateUId
                            ? { ...action.payload.templateUId }
                            : action.payload.templateUId === ''
                            ? ''
                            : state.cartData.templateUId,
                        lastUpdated: Date.now()
                    },
                };
            }
        }
        case UPDATE_CART_DATA:
            return {
                ...state,
                cartData: {
                    products: updateCartProducts(
                        state.cartData.products,
                        action.payload
                    ),
                },
            };

        case UPDATE_CART_DATA_SHIPPING:
            return {
                ...state,
                cartData: {
                    products: updateCartProductsShipping(
                        state.cartData.products,
                        action.payload.newFields,
                        action.payload.productKeys,
                        action.payload.isReservationBatch
                    ),
                },
            };
        case SET_PRICING_NOTES:
            return {
                ...state,
                cartData: {
                    products: state.cartData.products,
                    pricingNotes: action.payload,
                },
            };
        case SET_SHIPPING_DETAILS: {
            const targetKey = action.payload.salesOrg ===
                TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                    ? TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                    : TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue;
            return {
                ...state,
                shippingDetails: {
                    ...state.shippingDetails,
                    [targetKey]: {
                        ...state.shippingDetails[targetKey],
                        ...handlePayloadFunc(
                            state.shippingDetails[targetKey],
                            action.payload,
                            action.payload.objParams
                        ),
                    },
                },
            };
        }
        case SET_SHIPPING_DETAILS_EDIT_MODE:
            return {
                ...state,
                shippingDetails: action.payload,
            };
        case SET_SHIPPING_ADDRESS:
            return {
                ...state,
                shippingAddress: action.payload,
            };
        case HANDLE_SURGERY_NOTES:
            return {
                ...state,
                notes: action.payload,
            };
        case SET_VISUALIZATION_INSPECTION:
            return {
                ...state,
                visualInspectionAcknowledgement: action.payload,
            };
        case RESET_SURGERY_DETAILS:
            return {
                ...state,
                ...initialState,
                shippingDetails: {
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
                        attention: '',
                        payment: {
                            poAttachment: '',
                            poNumber: '',
                        },
                        salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
                        shippingAddressId: '',
                        shippingMethodId: '',
                        userAcknowledgement: false,
                    },
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
                        attention: '',
                        payment: {
                            poAttachment: '',
                            poNumber: '',
                        },
                        salesOrg: '',
                        shippingAddressId: '',
                        shippingMethodId: '',
                        userAcknowledgement: false,
                    },
                },
            };
        case SET_SURGERY_NUMBER:
            return {
                ...state,
                surgeryDetails: {
                    ...state.surgeryDetails,
                    surgeryNumber: action.payload,
                },
            };
        case CHANGE_SHIPPING_SEGMENT_INDEX:
            return {
                ...state,
                selectedShippingSegment: action.payload,
            };
        case CHANGE_ACKNOWLEGMENT_VIEW:
            return {
                ...state,
                showAcknowlegment: {
                    ...state.showAcknowlegment,
                    [action.payload.name]: action.payload.value,
                },
            };
        case CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case DISABLE_SURGERY_DATE:
            return {
                ...state,
                disableSurgeryDate: action.payload,
            };
        case NOTES_VISITED:
            return {
                ...state,
                isNotesVisited: action.payload,
            };
        case CURRENT_SURGERY_DATE_SELECTED:
            return {
                ...state,
                currentSurgeryDateSelected: action.payload,
            };
        case SET_SCHEDULE_SURGERY_CU_IN_PROGRESS:
            return {
                ...state,
                surgeryCUInProgress: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS:
            return {
                ...state,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_SUCCESS:
            return {
                ...state,
                recenlyUsedPhysicians: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_FAILURE:
            return {
                ...state,
                recenlyUsedPhysicians: action.templateError,
            };
        case GET_DERIVED_TERRITORIES:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryLoading: true,
            };

        case SET_DERIVED_TERRITORIES_SUCCESS:
            return {
                ...state,
                derivedTerritoryDetails: {
                    ...state.derivedTerritoryDetails,
                    interTerritoryId: action.interTerritoryId,
                    nonInterTerritoryId: action.nonInterTerritoryId,
                    derivedResponse: action.derivedResponse,
                },
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };

        case SET_DERIVED_TERRITORIES_FAILURE:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };
        case GET_HOLIDAY_LIST_SUCCESS:
            return {
                ...state,
                isHoliday: action.payload,
            };
        case SET_SURGERY_DETAILS_GENERIC:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };

        case SET_PRODUCT_TEMPLATE_UID: {
            let temp =
                state.productTemplateUID.length >= 1
                    ? state.productTemplateUID.split(',')
                    : state.productTemplateUID.split('');
            temp.push(action.payload);
            return {
                ...state,
                productTemplateUID: temp.join(','),
            };
        }
        case SET_UNKNOWN_CHECKBOX:
            return {
                ...state,
                unknownCheckbox: action.payload,
            };
        case SET_ITEM_LIST_CLICKED:
            return {
                ...state,
                isItemListClicked: action.payload,
            };
        case SET_IMPLANT_AND_INSTRUMENT_PRODUCTS:
            return {
                ...state,
                implantProducts: action.payload.implantProducts ? action.payload.implantProducts : state.implantProducts,
                instrumentProducts: action.payload.instrumentProducts ? action.payload.instrumentProducts : state.instrumentProducts,
                setImplantProducts: action.payload.setImplantProducts,
                setInstrumentProducts: action.payload.setInstrumentProducts,
                itemImplantProducts: action.payload.itemImplantProducts,
                itemInstrumentProducts: action.payload.itemInstrumentProducts,
            };
        case SET_SHIP_TO_ADDRESS_VALUE:
            return {
                ...state,
                shipToAddressValue: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'surgeryKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    SurgeryReducer
);
